import { buttonModes, sizes } from '@/utils'

import copyButton from '@/components/button/copy'
import overflow from '@/components/text/overflow'

function renderCopyButton(h) {
  if (this.hasContent && this.copy) {
    return h(
      'div',
      {
        class: 'info-card__copy'
      },
      [
        h(
          copyButton,
          {
            props: {
              value: this.value,
              size: sizes.tiny,
              mode: buttonModes['flat-icon'],
              tooltip: this.getTranslate('misc.buttons.copy')
            }
          }
        )
      ]
    )
  }
}
function renderLabel(h) {
  if (this.label) {
    return h(
      'div',
      {
        class: 'info-card__content-label'
      },
      [
        h(
          overflow,
          {
            props: {
              value: this.label
            }
          }
        )
      ]
    )
  }
}
function renderText(h) {
  return h(
    'div',
    {
      class: 'info-card__content-text',
      domProps: { innerHTML: this.value }
    }
  )
}
function renderContent(h) {
  if (this.hasContent) {
    return h(
      'div',
      {
        class: 'info-card__content'
      },
      [
        renderLabel.call(this, h),
        renderText.call(this, h)
      ]
    )
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: this.$_class
    },
    [
      renderContent.call(this, h),
      renderCopyButton.call(this, h)
    ]
  )
}
